import React, { useContext } from 'react';
import { Footer as FooterBase, LocaleContext } from 'shared';
import { getEnvironmentVar } from 'utils';

export const Footer = () => {
  const localeContext = useContext(LocaleContext);
  const spaUrl = getEnvironmentVar('REACT_APP_SPA_URL');

  return (
    <FooterBase
      links={[
        {
          external: true,
          label: localeContext.formatMessage({ id: 'FOOTER.SERVICE-POLICY' }),
          url: `${spaUrl}pages/service-policy`,
        },
        {
          external: true,
          label: localeContext.formatMessage({ id: 'FOOTER.CONTACT' }),
          url: `${spaUrl}contact`,
        },
      ]}
    />
  );
};
